import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createHead } from '@vueuse/head'

import { createBootstrap } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faFlickr, faInstagram, faGithubSquare, faYoutubeSquare, faFacebookSquare, faLinkedin, faSpotify
} from '@fortawesome/free-brands-svg-icons'
import {
  faSpinner, faEnvelope, faEnvelopeSquare, faBook
} from '@fortawesome/free-solid-svg-icons'
import Landing from "@/routes/Landing";
import Pidging from "@/routes/Pidging";
import NotFound from "@/routes/NotFound";
import Picturevert from "@/routes/Picturevert";
import Fiction from "@/routes/Fiction.vue";
import PhotoGallery from "@/routes/PhotoGallery.vue";

library.add(
    faFlickr, faInstagram, faGithubSquare, faYoutubeSquare, faFacebookSquare, faLinkedin, faSpinner, faEnvelope, faEnvelopeSquare, faSpotify, faBook
)

const routes = [
  {
    path: '/',
    component: Landing
  },
  {
    path: '/pidging',
    component: Pidging
  },
  {
    path: '/picturevert',
    component: Picturevert
  },
  {
    path: '/fiction',
    component: Fiction
  },
  {
    path: '/gallery/:year',
    component: PhotoGallery
  },
  {
    path: '/tech',
    component: Landing
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
})

const head = createHead()

const app = createApp(App)

app.use(createBootstrap())
app.use(router)
app.use(head)
app.component('font-awesome-icon', FontAwesomeIcon)

app.mount('#app')
